/**
 * What an ordinary phone shows when someone taps an LGU card (the chip holds a link to
 * /t with a one-time code). It never shows who the card belongs to or any balance —
 * only what the card is and how to report it lost (FR-CRD-01, privacy by design).
 */
import { Landmark, Phone } from 'lucide-react';
import { useI18n } from '../../lib/i18n';
import { usePublicSettings } from '../../lib/queries';

export function CardLanding(): JSX.Element {
  const { t } = useI18n();
  const s = usePublicSettings();
  return (
    <main className="grid min-h-dvh place-items-center bg-paper px-4 py-10">
      <div className="w-full max-w-sm rounded-ticket border border-line bg-card p-6 text-center shadow-lift">
        <span className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-brand text-brand-ink"><Landmark aria-hidden className="h-7 w-7" /></span>
        <h1 className="display mt-4 text-2xl">{s.data?.lguName ?? 'LGU'}</h1>
        <p className="mt-2 text-base">{t('This is an LGU assistance card. It works only at accredited stores, with the owner\'s PIN.')}</p>
        <p className="mt-4 text-sm text-muted">{t('Found this card? Please return it to the LGU office.')}</p>
        {s.data?.hotline && (
          <a href={`tel:${s.data.hotline.replace(/\s/g, '')}`} className="mt-4 inline-flex min-h-12 items-center gap-2 rounded-xl bg-brand px-5 font-semibold text-brand-ink">
            <Phone aria-hidden className="h-4 w-4" />{t('Lost card hotline')} {s.data.hotline}
          </a>
        )}
      </div>
    </main>
  );
}
